<template>
  <a-modal
    :title="type == 'add' ? '新建员工' : '编辑员工'"
    okText="保存"
    @ok="save"
    v-model="visible"
    destroyOnClose
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="650"
  >
    <a-form :form="form">
      <h3>个人信息及账号</h3>
      <a-row :gutter="30">
        <a-col span="12">
          <a-form-item label="姓名">
            <a-input
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请填写姓名' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item label="手机">
            <a-input
              v-decorator="[
                'tel',
                { rules: [{ required: true, message: '请填写手机' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item label="邮箱（登录账号）">
            <a-input
              v-decorator="[
                'email',
                { rules: [{ required: true, message: '请填写邮箱' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item label="微信号（用于猎头咨询）">
            <a-input
              v-decorator="[
                'work_wechat_id',
                { rules: [{ required: true, message: '请填写微信号' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="24">
          <a-row type="flex" align="top" :gutter="30">
            <a-col span="12">
              <a-row>
                <a-col span="24">
                  <a-form-item label="密码">
                    <a-input
                      v-if="type==='edit'"
                      v-decorator="[
                        'pass',
                        {
                          rules: [
                            { required: false, message: '请设置密码' },
                            { min: 8, message: '最小长度为8位' },
                            { pattern:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,trigger: 'blur', message: '由数字、字母和特殊字符组合',required:true },

                          ]
                        }
                      ]"
                    ></a-input>
                    <a-input
                      v-else
                      v-decorator="[
                        'pass',
                        {
                          rules: [
                            { required: true, message: '请设置密码' },
                            { min: 8, message: '最小长度为8位' },
                            { pattern:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,trigger: 'blur', message: '由数字、字母和特殊字符组合',required:true },

                          ]
                        }
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col span="24">
                  <a-form-item label="角色设置">
                    <a-select
                      placeholder="请设置角色"
                      v-decorator="[
                        'role_id',
                        { rules: [{ required: true, message: '请设置角色' }] }
                      ]"
                    >
                      <template v-for="role in roles">
                        <a-select-option :key="role.id" :value="role.id">{{ role.name }}</a-select-option>
                      </template>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col span="12">
              <a-form-item label="微信二维码（用于猎头咨询）">
                <a-upload
                  class="qrcode-uploader"
                  :showUploadList="false"
                  listType="picture-card"
                  v-decorator="[
                    'work_wechat_qr',
                    {
                      valuePropName: 'file',
                      getValueFromEvent: normFile,
                      rules: [{ required: true, message: '请设置二维码' }]
                    }
                  ]"
                  name="file"
                  :action="uploadUrl"
                  @change="handleUpload"
                >
                  <div class="avatar">
                    <img v-if="qrcode" :src="qrcode" alt style="max-width:100%;" />
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <h3>组织机构</h3>
      <a-row :gutter="30">
        <a-col span="12">
          <a-form-item label="所属机构">
            <a-cascader
              changeOnSelect
              :options="officeOptions"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              placeholder="请设置机构"
              style="display:block"
              v-decorator="[
                'office_path',
                { rules: [{ required: true, message: '请设置机构' }] }
              ]"
            ></a-cascader>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item label="汇报对象">
            <a-auto-complete
              :dataSource="dataSource"
              @search="handleSearch"
              v-decorator="[
                'superior_user_id',
                { rules: [{ required: true, message: '请填写汇报对象' }] }
              ]"
              placeholder="请填写汇报对象"
            ></a-auto-complete>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item label="员工编号">
            <a-input placeholder="请填写员工编号" v-decorator="['staff_no']"></a-input>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item label="职位">
            <a-input placeholder="请填写职位" v-decorator="['title']"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
import debounce from "lodash/debounce";
export default {
  name: "EditStaffModal",
  data() {
    this.handleSearch = debounce(this.handleSearch, 800);
    return {
      form: this.$form.createForm(this),
      qrcode: "",
      loading: false,
      uploadUrl: process.env.VUE_APP_BASEURL + "/common/file/upload",
      type: "",
      record: "",
      visible: false,
      confirmLoading: false,
      roles: [],
      officeOptions: [],
      dataSource: []
    };
  },
  methods: {
    save() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!this.checkIE(values)) {
            this.form.setFields({
              superior_user_id: {
                value: "",
                errors: [{ message: "请确认汇报对象" }]
              }
            });
            return;
          }
          this.confirmLoading = true;
          let params = {
            ...values,
            work_wechat_qr: Array.isArray(values.work_wechat_qr)
              ? values.work_wechat_qr[0].response.data.key
              : values.work_wechat_qr,
            office_path: JSON.stringify(values.office_path)
          };
          if (this.type == "edit") {
            params.uid = this.record.uid;
            try {
              await Api.office.updateUser(params);
              this.close();
              this.$emit("ok");
            } catch (e) {}
            this.confirmLoading = false;
          } else {
            try {
              await Api.office.createUser(params);
              this.close();
              this.$emit("ok");
            } catch (e) {}
            this.confirmLoading = false;
          }
        }
      });
    },
    async show(record) {
      await this.init();
      if (record) {
        this.record = record;
        this.type = "edit";
        let { user } = await Api.office.getUserDetail({ id: record.uid });
        this.visible = true;
        this.$nextTick().then(() => {
          this.initForm(user);
        });
      } else {
        this.qrcode = "";
        this.type = "add";
        this.visible = true;
      }
    },
    async initUser(id) {
      let { user } = await Api.office.getUserDetail({ id });
      this.user = user;
    },
    initForm(user) {
      this.qrcode = user.work_wechat_qr_url;
      this.form.setFieldsValue({
        name: user.name,
        tel: user.tel,
        email: user.email,
        work_wechat_id: user.work_wechat_id,
        work_wechat_qr: user.work_wechat_qr,
        role_id: user.role_id,
        office_path: user.office_path ? JSON.parse(user.office_path) : [],
        staff_no: user.staff_no,
        superior_user_id: user.superior_user_id,
        title: user.title
      });
      //init DataSource fix
      this.dataSource =
        user.superior_user_id > 0
          ? [{ value: user.superior_user_id, text: user.superior_user_name }]
          : [];
    },
    async init() {
      let { roles } = await Api.system.getRoleList();
      this.roles = roles;
      let { tree } = await Api.office.getTree();
      this.officeOptions = tree;
    },
    close() {
      this.visible = false;
      this.qrcode = "";
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    handleUpload(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status == "done") {
        this.loading = false;
        this.qrcode = info.file.response.data.url;
      }
    },
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.dataSource = arr;
    },
    checkIE(value) {
      if (this.dataSource.length === 0) {
        return false;
      } else {
        return (
          this.dataSource.filter(item => item.value == value.superior_user_id)
            .length > 0
        );
      }
    }
  }
};
</script>

<style lang="scss">
.qrcode-uploader > .ant-upload {
  width: 128px;
  height: 128px;
  position: relative;
  .avatar {
    i {
      font-size: 32px;
      color: #999;
    }
    .ant-upload-text {
      color: #888;
      margin-top: 8px;
    }
  }
}
</style>
